import { useEffect, useState } from 'react'
import { Superpose } from './Superpose'
import { useHistorique } from '../lib/historique'
import { horodatageCourt } from '../lib/format'
import { ICONE_AVIS, marquerLus, rafraichirAvis, surAvis, type Avis } from '../lib/avis'

/**
 * Cloche des avis, dans l'en-tête. Un toucher ouvre la liste ; toucher un
 * avis ouvre le chantier et la fiche du suivi. Relecture toutes les 2 minutes
 * et au retour dans l'application.
 */
export function Cloche({ aller }: { aller: (chantierId: string, suiviId: string | null) => void }) {
  const [avis, setAvis] = useState<Avis[]>([])
  const [ouverte, setOuverte] = useState(false)
  useHistorique(ouverte, setOuverte)

  useEffect(() => surAvis(setAvis), [])
  useEffect(() => {
    void rafraichirAvis()
    const t = setInterval(() => void rafraichirAvis(), 120_000)
    const visible = () => document.visibilityState === 'visible' && void rafraichirAvis()
    document.addEventListener('visibilitychange', visible)
    window.addEventListener('online', visible)
    return () => {
      clearInterval(t)
      document.removeEventListener('visibilitychange', visible)
      window.removeEventListener('online', visible)
    }
  }, [])

  const nonLus = avis.filter((a) => !a.lu_le)

  function choisir(a: Avis) {
    void marquerLus([a.id])
    setOuverte(false)
    if (a.chantier_id) aller(a.chantier_id, a.suivi_id)
  }

  return (
    <>
      <button
        className={`cloche ${nonLus.length ? 'active' : ''}`}
        onClick={() => {
          setOuverte(true)
          void rafraichirAvis()
        }}
        aria-label={`Avis${nonLus.length ? ` : ${nonLus.length} non lus` : ''}`}
        title="Avis"
      >
        <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
          <path d="M6 16V11a6 6 0 0 1 12 0v5l1.5 2h-15L6 16Z" />
          <path d="M10 20a2 2 0 0 0 4 0" />
        </svg>
        {nonLus.length > 0 && <span className="cloche-compte">{nonLus.length > 99 ? '99+' : nonLus.length}</span>}
      </button>

      {ouverte && (
        <Superpose className="feuille">
          <header className="entete">
            <div className="entete-rang">
              <button className="retour" onClick={() => setOuverte(false)}>
                ‹ Retour
              </button>
              <div style={{ flex: 1 }}>
                <h1>Avis</h1>
                <p className="sous">{nonLus.length ? `${nonLus.length} non lu${nonLus.length > 1 ? 's' : ''}` : 'Tout est lu'}</p>
              </div>
              <button className="fermer-x" onClick={() => setOuverte(false)} aria-label="Fermer">
                ✕
              </button>
            </div>
          </header>
          <div className="corps">
            {nonLus.length > 0 && (
              <button className="bouton creux" style={{ marginBottom: 12 }} onClick={() => void marquerLus(nonLus.map((a) => a.id))}>
                Tout marquer lu
              </button>
            )}
            {avis.length === 0 && (
              <p className="vide">
                Aucun avis pour l'instant.
                <br />
                Tu en recevras quand un suivi te sera assigné, à l'approche d'une échéance, ou quand une déficience sera à valider.
              </p>
            )}
            <div className="liste">
              {avis.map((a) => (
                <button key={a.id} className={`carte avis-ligne ${a.lu_le ? 'lu' : ''}`} onClick={() => choisir(a)}>
                  <span className={`avis-icone t-${a.type}`} aria-hidden="true">
                    {ICONE_AVIS[a.type]}
                  </span>
                  <span style={{ minWidth: 0, flex: 1 }}>
                    <span className="titre">{a.titre}</span>
                    {a.texte && <span className="meta" style={{ display: 'block' }}>{a.texte}</span>}
                    <span className="code">{horodatageCourt(a.cree_le)}</span>
                  </span>
                </button>
              ))}
            </div>
          </div>
        </Superpose>
      )}
    </>
  )
}
